import React, { useRef, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { useForm } from "react-hook-form";

import ContactCategoryLangs from './_langs.js'
import { showLoader } from "../../../components/loader/loader";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { PH_CODE, PH_ICON } from "../../../components/i18n/placeHolders";
import { FL_CODE, FL_ICON } from "../../../components/i18n/formLabels";
import { FORM, INTERNATIONAL, LB_ACTIVE, LB_ORDER, REQUIRED } from "../../../components/i18n/i18n";
import { contactCategoryService } from "../../../jwt/_services/xailing/contactCategoryService";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import TranslatedLangs from "../../../components/genericComponents/TranslatedLangs";

const ContactCategoryForm = ( props ) => {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const translatableLangs = savedData?.translatedLangs || []

    const [status, setStatus] = useState(editMode ? props.item?.status : false);

    const refLangs = useRef(null);
    const [langChilds, setLangChilds] = useState([]);

    //Formulario
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id        : savedData?.id,
            code      : savedData?.code,
            icon      : savedData?.icon,
            status    : savedData?.status,
            showOrder : savedData?.showOrder,
        }
    });

    const onSubmit = (data, _) => {
        let info = JSON.parse(JSON.stringify(data))

        const dataRequest = {
            fbDataBase:  { id : fbDataBaseId },
            item: {
                ...info,
                status: status,
            }
        }

        if (langChilds != null && langChilds.length !== 0)
            dataRequest.item.langs = langChilds;

        setLoading(true);

        if (!editMode) {
            return contactCategoryService.saveItem(dataRequest)
                .then(resultData => setResult(resultData))
                .finally( ()=> setLoading(false) );
        } else {
            let id = savedData.id;
            dataRequest.item.id = savedData?.id

            return contactCategoryService.updateItem(id, dataRequest)
                .then(resultData => setResult(resultData))
                .finally( ()=> setLoading(false) );
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
        refLangs.current.changeDisabledInput(true, resultData?.langs);
    }

    const resetForm = () => {
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        refLangs.current.resetForm();
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        refLangs.current.changeDisabledInput(false, savedData?.langs);
    }

    const setForm = () => props.setForm(null, null, "LIST");

    const updateLangChilds = (langChildsP) => {
        if (langChildsP !== undefined)
            setLangChilds(langChildsP);
    }

    return (
        <Card>
            { loading ? showLoader() : null }

            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{FL_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                    disabled={disableInputs}
                                    className={(errors.code ? ' is-invalid' : '')}
                                />
                                { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{FL_ICON}</Label>
                                <Input
                                    type="text"
                                    name="icon"
                                    placeholder={PH_ICON}
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{LB_ORDER}</Label>
                                <Input
                                    type="number"
                                    name="showOrder"
                                    placeholder="Orden"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{LB_ACTIVE}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={ status }
                                    disabled={ disableInputs }
                                    onChange={ value => setStatus(!status) }
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        {INTERNATIONAL}
                    </CardTitle>

                    <CardBody>
                        <TranslatedLangs translatableLangs={translatableLangs} />
                        <ContactCategoryLangs
                            key="PlaceLangID"
                            ref={ refLangs }
                            contactCategory={savedData}
                            setForm={ setForm }
                            updateItem={ updateLangChilds }
                            editMode={ editMode }
                            disableInputs={ disableInputs }
                        />
                    </CardBody>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => resetForm() }/>
                                    <ButtonEdit onClick={() => beginEdit() }/>
                                    <ButtonCancel onClick={ setForm }/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={ setForm }/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}

export default ContactCategoryForm
